import { call, put, takeEvery, select } from "redux-saga/effects"
import * as actionTypes from "./actionTypes"
import * as actions from "./actions"
import { db } from "helpers/firebase/firebaseConfig"
import { collection, getDocs, query } from "firebase/firestore"

// Cache the result to avoid repeated queries
let maintenanceModeCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

async function fetchMaintenanceModeApi() {
  try {
    // Check if cache is still valid
    if (maintenanceModeCache !== null && cacheTimestamp && Date.now() - cacheTimestamp < CACHE_DURATION) {
      console.log("Using cached maintenance mode:", maintenanceModeCache);
      return maintenanceModeCache;
    }

    const q = query(collection(db, "platform_settings"))
    const querySnapshot = await getDocs(q)
    
    if (!querySnapshot.empty) {
      const settingsDoc = querySnapshot.docs[0]
      const settingsData = settingsDoc.data()
      // Check for both 'maintenance' and 'maintenance_mode' field names
      const result = settingsData?.maintenance || settingsData?.maintenance_mode || false;
      
      // Update cache
      maintenanceModeCache = result;
      cacheTimestamp = Date.now();
      
      return result;
    }
    
    // Update cache
    maintenanceModeCache = false;
    cacheTimestamp = Date.now();
    return false;
  } catch (error) {
    console.error("Error fetching maintenance mode:", error)
    // Return cached value or false on error
    return maintenanceModeCache !== null ? maintenanceModeCache : false;
  }
}

function* fetchMaintenanceMode() {
  try {
    const isMaintenanceMode = yield call(fetchMaintenanceModeApi)
    yield put(actions.fetchMaintenanceModeSuccess(isMaintenanceMode || false))
  } catch (error) {
    console.error("Maintenance mode fetch error:", error)
    // Still set as false on error to prevent blocking the app
    yield put(actions.fetchMaintenanceModeSuccess(false))
  }
}

function* maintenanceSaga() {
  yield takeEvery(actionTypes.FETCH_MAINTENANCE_MODE, fetchMaintenanceMode)
}

export default maintenanceSaga
